import type { Editor } from "@tiptap/core";
import type { ObjectTypeKey } from "schemas/objectType";

import React from "react";

import { useIntegrationObjectSearch } from "@agent-ui/features/chat/hooks/useIntegrationObjectSearch";
import { selectIntegrationObject } from "@agent-ui/features/chat/utils/contextItem";

import { IntegrationObjectContextItemsList } from "./IntegrationObjectContextItemsList";

interface IntegrationObjectTabProps {
  integrationKey: string;
  objectType: ObjectTypeKey;
  displayName: string;
  tabValue: string;
  searchQuery: string;
  isActiveTab: boolean;
  scrollableTargetId: string;
  editor: Editor | null;
  onClose?: () => void;
}

export const IntegrationObjectTab: React.FC<IntegrationObjectTabProps> = ({
  integrationKey,
  objectType,
  displayName,
  tabValue,
  searchQuery,
  isActiveTab,
  scrollableTargetId,
  editor,
  onClose,
}) => {
  const { results, isLoading, fetchNextPage, hasNextPage } =
    useIntegrationObjectSearch({
      integrationKey,
      objectType,
      query: searchQuery,
      enabled: isActiveTab,
    });

  const handleSelect = React.useCallback(
    (result: {
      id: string;
      title?: string;
      handle?: string;
      imageUrl?: string | null;
    }) => {
      selectIntegrationObject({
        integrationKey,
        objectType,
        object: result,
        editor,
      });
      onClose?.();
    },
    [integrationKey, objectType, editor, onClose],
  );

  return (
    <div className="max-h-[340px] overflow-y-auto" id={scrollableTargetId}>
      <IntegrationObjectContextItemsList
        results={results}
        isLoading={isLoading}
        searchQuery={searchQuery}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        onSelect={handleSelect}
        scrollableTargetId={scrollableTargetId}
        listContainerId={tabValue}
        emptyTitle={`No ${displayName} Found`}
        emptySearchTitle={`No ${displayName} Found`}
      />
    </div>
  );
};
